 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import ALST from '@/components/alst'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1XHTMLCOVER from '@/components/Book1/xhtml/cover'
 import BOOK1XHTMLTITLE from '@/components/Book1/xhtml/title'
 import BOOK1XHTMLCHAPTER001 from '@/components/Book1/xhtml/chapter001'
 import BOOK1XHTMLCHAPTER002 from '@/components/Book1/xhtml/chapter002'
 import BOOK1XHTMLCHAPTER003 from '@/components/Book1/xhtml/chapter003'
 import BOOK1XHTMLCHAPTER004 from '@/components/Book1/xhtml/chapter004'
 import BOOK1XHTMLCHAPTER005 from '@/components/Book1/xhtml/chapter005'
 import BOOK1XHTMLCHAPTER006 from '@/components/Book1/xhtml/chapter006'
 import BOOK1XHTMLCHAPTER007 from '@/components/Book1/xhtml/chapter007'
 import BOOK1XHTMLCHAPTER008 from '@/components/Book1/xhtml/chapter008'
 import BOOK1XHTMLCHAPTER009 from '@/components/Book1/xhtml/chapter009'
 import BOOK1XHTMLCHAPTER010 from '@/components/Book1/xhtml/chapter010'
 import BOOK1XHTMLCHAPTER011 from '@/components/Book1/xhtml/chapter011'
 import BOOK1XHTMLCHAPTER012 from '@/components/Book1/xhtml/chapter012'
 import BOOK1XHTMLCHAPTER013 from '@/components/Book1/xhtml/chapter013'
 import BOOK2XHTMLCOVER from '@/components/Book2/xhtml/cover'
 import BOOK2XHTMLTITLE from '@/components/Book2/xhtml/title'
 import BOOK2XHTMLCHAPTER001 from '@/components/Book2/xhtml/chapter001'
 import BOOK2XHTMLCHAPTER002 from '@/components/Book2/xhtml/chapter002'
 import BOOK2XHTMLCHAPTER003 from '@/components/Book2/xhtml/chapter003'
 import BOOK2XHTMLCHAPTER004 from '@/components/Book2/xhtml/chapter004'
 import BOOK2XHTMLCHAPTER005 from '@/components/Book2/xhtml/chapter005'
 import BOOK2XHTMLCHAPTER006 from '@/components/Book2/xhtml/chapter006'
 import BOOK2XHTMLCHAPTER007 from '@/components/Book2/xhtml/chapter007'
 import BOOK2XHTMLCHAPTER008 from '@/components/Book2/xhtml/chapter008'
 import BOOK2XHTMLCHAPTER009 from '@/components/Book2/xhtml/chapter009'
 import BOOK2XHTMLCHAPTER010 from '@/components/Book2/xhtml/chapter010'
 import BOOK2XHTMLCHAPTER011 from '@/components/Book2/xhtml/chapter011'
 import BOOK2XHTMLCHAPTER012 from '@/components/Book2/xhtml/chapter012'
 import BOOK2XHTMLCHAPTER013 from '@/components/Book2/xhtml/chapter013'
 import BOOK2XHTMLCHAPTER014 from '@/components/Book2/xhtml/chapter014'
 import BOOK2XHTMLCHAPTER015 from '@/components/Book2/xhtml/chapter015'
 import BOOK2XHTMLCHAPTER016 from '@/components/Book2/xhtml/chapter016'
 import BOOK2XHTMLFM_02 from '@/components/Book2/xhtml/fm_02'
 import BOOK3XHTMLCOVER from '@/components/Book3/xhtml/cover'
 import BOOK3XHTMLTITLE from '@/components/Book3/xhtml/title'
 import BOOK3XHTMLCHAPTER001 from '@/components/Book3/xhtml/chapter001'
 import BOOK3XHTMLCHAPTER002 from '@/components/Book3/xhtml/chapter002'
 import BOOK3XHTMLCHAPTER003 from '@/components/Book3/xhtml/chapter003'
 import BOOK3XHTMLCHAPTER004 from '@/components/Book3/xhtml/chapter004'
 import BOOK3XHTMLCHAPTER005 from '@/components/Book3/xhtml/chapter005'
 import BOOK3XHTMLCHAPTER006 from '@/components/Book3/xhtml/chapter006'
 import BOOK3XHTMLCHAPTER007 from '@/components/Book3/xhtml/chapter007'
 import BOOK3XHTMLCHAPTER008 from '@/components/Book3/xhtml/chapter008'
 import BOOK3XHTMLCHAPTER009 from '@/components/Book3/xhtml/chapter009'
 import BOOK3XHTMLCHAPTER010 from '@/components/Book3/xhtml/chapter010'
 import BOOK3XHTMLCHAPTER011 from '@/components/Book3/xhtml/chapter011'
 import BOOK3XHTMLCHAPTER012 from '@/components/Book3/xhtml/chapter012'
 import BOOK3XHTMLCHAPTER013 from '@/components/Book3/xhtml/chapter013'
 import BOOK3XHTMLCHAPTER014 from '@/components/Book3/xhtml/chapter014'
 import BOOK3XHTMLCHAPTER015 from '@/components/Book3/xhtml/chapter015'
 import LOVE_2 from '@/components/love_2'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONAUBA from '@/components/Comon/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/xhtml/cover",
 			"name" : "Book1/xhtml/cover",
 			"component" : BOOK1XHTMLCOVER
 		},
 		{
 			"path" : "/Book1/xhtml/title",
 			"name" : "Book1/xhtml/title",
 			"component" : BOOK1XHTMLTITLE
 		},
 		{
 			"path" : "/Book1/xhtml/chapter001",
 			"name" : "Book1/xhtml/chapter001",
 			"component" : BOOK1XHTMLCHAPTER001
 		},
 		{
 			"path" : "/Book1/xhtml/chapter002",
 			"name" : "Book1/xhtml/chapter002",
 			"component" : BOOK1XHTMLCHAPTER002
 		},
 		{
 			"path" : "/Book1/xhtml/chapter003",
 			"name" : "Book1/xhtml/chapter003",
 			"component" : BOOK1XHTMLCHAPTER003
 		},
 		{
 			"path" : "/Book1/xhtml/chapter004",
 			"name" : "Book1/xhtml/chapter004",
 			"component" : BOOK1XHTMLCHAPTER004
 		},
 		{
 			"path" : "/Book1/xhtml/chapter005",
 			"name" : "Book1/xhtml/chapter005",
 			"component" : BOOK1XHTMLCHAPTER005
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js